import { FuelTypes, RetrieveCartItem, RetrieveCartResponse } from '@aglenergy/shared-library';
import { ObservableMap } from '@stencil/store';
import { removeHandler } from 'app/shared/store/handlers/types/remove-handler';
import { State } from 'app/shared/store/models/state.model';

const dispatchCartLoadedEvent = (cartResponse: RetrieveCartResponse): void => {
  if (cartResponse?.cartItems?.length) {
    const itemIds: string[] = [];
    cartResponse.cartItems.forEach((item: RetrieveCartItem): void => {
      const itemFuelType: FuelTypes = item.additionalData?.productQualification?.fuelType;
      if (itemFuelType === FuelTypes.ELECTRICITY || itemFuelType === FuelTypes.DUAL) {
        itemIds[0] = item.sku;
      }
      if (itemFuelType === FuelTypes.GAS || itemFuelType === FuelTypes.DUAL) {
        itemIds[1] = item.sku;
      }
    });

    if (!itemIds.length) {
      return;
    }
    const elem = document.querySelector('#app-comparison');
    if (!elem) {
      return;
    }
    const event = new CustomEvent('cartLoaded', { detail: `{"itemIds": "${itemIds}"}` });
    elem.dispatchEvent(event);
  }
};

export const dispatchResetCartEvent = (): void => {
  const elem = document.querySelector('#app-comparison');
  if (elem) {
    elem.dispatchEvent(new CustomEvent('cartLoaded', { detail: '{"offerId": ""}' }));
  }
};

export const cartHandler = (store: ObservableMap<State>): removeHandler => {
  return store.onChange('cart', (cartDetails) => {
    dispatchCartLoadedEvent(cartDetails);
  });
};
